export default {
  notifications: [],
};
